module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"engineRebuildingOrderHistory":"Historial de Órdenes de la Rectificadora"},"en":{"engineRebuildingOrderHistory":"Engine Rebuilding Order History"}}')
  delete Component.options._Ctor
}
